/*
  This file contains the styles for the delete section dialog.
*/

import { Stack, styled } from '@mui/material';

// This is the content of the dialog.
export const DialogContent = styled(Stack)({
  padding: '20px 22px',
  maxWidth: 500,
  '& .sectionBox': {
    height: 61,
    backgroundColor: 'rgba(235, 234, 255, 1)',
    borderRadius: 9,
    padding: '10px 12px',
    borderColor: '1px solid blue',

    display: 'flex',
    alignItems: 'center',
    gap: 10,

    '& .iconBox': {
      height: 36,
      width: 36,
      backgroundColor: 'rgba(104, 104, 254, 1)',
      borderRadius: 8,

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      '& .icon': {
        height: 15,
        width: 15,

        '& path': {
          stroke: 'white',
        },
      },
    },

    '& .sectionText': {
      fontWeight: 800,
      fontSize: 15,
      lineHeight: '20.49px',
      color: 'rgba(0, 0, 0, 1)',
    },

    '& .sectionSteps': {
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '19.12px',
      color: 'rgba(33, 33, 33, 1)',
    },
  },
  '& .description': {
    fontWeight: 500,
    fontSize: 15,
    lineHeight: '26px',
    color: 'rgba(0, 0, 0, 1)',
    margin: '20px 0px 10px 0px',
  },
});
